export const GET_USER_ACTIVITY_TYPES_REQUEST = 'GET_USER_ACTIVITY_TYPES_REQUEST';
export const GET_USER_ACTIVITY_TYPES_SUCCESS = 'GET_USER_ACTIVITY_TYPES_SUCCESS';
export const GET_USER_ACTIVITY_TYPES_FAILED = 'GET_USER_ACTIVITY_TYPES_FAILED';

export const CREATE_USER_ACTIVITY_TYPE_REQUEST = 'CREATE_USER_ACTIVITY_TYPE_REQUEST';
export const CREATE_USER_ACTIVITY_TYPE_SUCCESS = 'CREATE_USER_ACTIVITY_TYPE_SUCCESS';
export const CREATE_USER_ACTIVITY_TYPE_FAILED = 'CREATE_USER_ACTIVITY_TYPE_FAILED';

export const GET_USER_ACTIVITY_TYPE_REQUEST = 'GET_USER_ACTIVITY_TYPE_REQUEST';
export const GET_USER_ACTIVITY_TYPE_SUCCESS = 'GET_USER_ACTIVITY_TYPE_SUCCESS';
export const GET_USER_ACTIVITY_TYPE_FAILED = 'GET_USER_ACTIVITY_TYPE_FAILED';

export const UPDATE_USER_ACTIVITY_TYPE_REQUEST = 'UPDATE_USER_ACTIVITY_TYPE_REQUEST';
export const UPDATE_USER_ACTIVITY_TYPE_SUCCESS = 'UPDATE_USER_ACTIVITY_TYPE_SUCCESS';
export const UPDATE_USER_ACTIVITY_TYPE_FAILED = 'UPDATE_USER_ACTIVITY_TYPE_FAILED';

export const GET_USER_ACTIVITY_TYPES_BY_URL_REQUEST = 'GET_USER_ACTIVITY_TYPES_BY_URL_REQUEST';
export const GET_USER_ACTIVITY_TYPES_BY_URL_SUCCESS = 'GET_USER_ACTIVITY_TYPES_BY_URL_SUCCESS';
export const GET_USER_ACTIVITY_TYPES_BY_URL_FAILED = 'GET_USER_ACTIVITY_TYPES_BY_URL_FAILED';

export const CREATE_USER_ACTIVITY_REQUEST = 'CREATE_USER_ACTIVITY_REQUEST';
export const CREATE_USER_ACTIVITY_SUCCESS = 'CREATE_USER_ACTIVITY_SUCCESS';
export const CREATE_USER_ACTIVITY_FAILED = 'CREATE_USER_ACTIVITY_FAILED';

export const REISSUE_EXPIRED_POINTS_REQUEST = 'REISSUE_EXPIRED_POINTS_REQUEST';
export const REISSUE_EXPIRED_POINTS_SUCCESS = 'CREATE_USER_ACTIVITY_SUCCESS';
export const REISSUE_EXPIRED_POINTS_FAILED = 'CREATE_USER_ACTIVITY_FAILED';

export const GET_CLASSIFICATIONS_REQUEST = 'GET_CLASSIFICATIONS_REQUEST';
export const GET_CLASSIFICATIONS_SUCCESS = 'GET_CLASSIFICATIONS_SUCCESS';
export const GET_CLASSIFICATIONS_FAILED = 'GET_CLASSIFICATIONS_FAILED';

export const GET_FREQUENCY_PERIODS_REQUEST = 'GET_FREQUENCY_PERIODS_REQUEST';
export const GET_FREQUENCY_PERIODS_SUCCESS = 'GET_FREQUENCY_PERIODS_SUCCESS';
export const GET_FREQUENCY_PERIODS_FAILED = 'GET_FREQUENCY_PERIODS_FAILED';

export const CLEAR_USER_ACITIVITY_TYPE = 'CLEAR_USER_ACITIVITY_TYPE';
